import avi from './img/avi-pink.png';

function Home(){
    return(
        <div className="container">
            <div className="row">
                <div className="col-sm">
                    <img src={avi} alt="my face looking super spiffy" id="avi" />
                    <br />
                    <span className="header gradient">David Marino</span> 
                    <br />
                    <span className="secondary">(they/them)</span>
                    <br />
                    <span className="secondary">Design researcher</span>
                </div>
                <div className="col-m">
                    <div>
                        <p>                            
                            Most technology isn't used. <br/> 
                            This is often not due to a failure in engineering, but a failure in understanding people. 
                            <br />
                            In order to design for people, you must understand people.<br />
                            I am interested in using the tools of design and psychology to make cool things, and figure out how people work in the process.
                        </p>

                    </div>
                    <div className="row fill">
                        <div className="col-50">
                            <span className="subheader">Interests</span>
                            <ul>
                                <li>Multimodal communication</li>
                                <li>Affective computing</li>
                                <li>Games</li>
                                <li>Subsymbolic aspects of natural language</li>
                                <li>Telepresence</li>
                                <li>HCI/HRI</li>

                            </ul>
                        </div>
                        <div className="col-50">
                            <span className="subheader">Education</span>
                            {/* <div>
                    <div className="emoji" role="img" aria-label="computer">💻</div>
                    <div className="indent">
                      MSc Electrical and Computer Engineering
                    </div>
                  </div> */}

                            <ul className="education-list">
                                <li>
                                    <div>
                                        MSc - Electrical and Computer Engineering (2021)<br />
                                        <span className="secondary">McGill University</span><br />
                                        <span className="secondary">Emphasis in HCI</span>
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        BA - Cognitive Systems (2016)<br />
                                        <span className="secondary">University of British Columbia</span><br />
                                        <span className="secondary">Emphasis in Language</span>
                                    </div>
                                </li>
                                {/* <li>
                      <div>
                      Certificate - Cinematography (2009)<br/>
                      <span className="secondary">Capilano University</span>
                      </div>
                    </li> */}
                            </ul>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    )
}

export {Home}